import serviceProject from "../serviceProject";
import { getRoles } from "../../../service";

const ContractPeriod = {
  ...serviceProject,
  getRoles,
  resource: "contract-periods",
  resourceRole: "contract-periods"
};
export default ContractPeriod;
